"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import { ButtonLink } from "@/components/ui/button-link";

interface HeroGradientProps {
  title: string;
  subtitle?: string;
  ctaText?: string;
  ctaHref?: string;
  ctaSubtext?: string;
}

const HeroGradient = ({ title, subtitle, ctaText, ctaHref, ctaSubtext }: HeroGradientProps) => {
  return (
    <section className="relative py-32 md:py-44 px-6 bg-gradient-to-br from-primary via-primary/90 to-secondary overflow-hidden">
      {/* Decorative background circles */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="absolute aspect-square w-[120%] rounded-full border border-white/10" />
        <div className="absolute aspect-square w-[80%] rounded-full border border-white/5" />
        <div className="absolute aspect-square w-[50%] rounded-full border border-white/5" />
      </div>

      <div className="container max-w-4xl mx-auto text-center relative z-10">
        {/* Title */}
        <BlurFade delay={0.1}>
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold tracking-tight text-white leading-[1.1]">
            {title}
          </h1>
        </BlurFade>

        {/* Subtitle */}
        {subtitle && (
          <BlurFade delay={0.2}>
            <p className="mt-6 text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          </BlurFade>
        )}

        {/* CTA */}
        {ctaText && ctaHref && (
          <BlurFade delay={0.3}>
            <div className="mt-10 flex flex-col items-center gap-3">
              <ButtonLink
                href={ctaHref}
                variant="secondary"
                size="lg"
                className="font-bold text-lg px-10 py-6"
              >
                {ctaText}
              </ButtonLink>
              {ctaSubtext && (
                <p className="text-sm text-white/60">{ctaSubtext}</p>
              )}
            </div>
          </BlurFade>
        )}
      </div>
    </section>
  );
};

export default HeroGradient;
